import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'
import './checks.scss'

const CheckCnep = ({ cnepCheck, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])

  const hasArrayChecks = Array.isArray(cnepCheck?.checkDetails) && cnepCheck.checkDetails.length > 0
  const hasObjectCheck = !Array.isArray(cnepCheck?.checkDetails) && cnepCheck?.checkDetails?.informação && cnepCheck.found;
  const checkLength = hasArrayChecks ? cnepCheck.checkDetails.length : hasObjectCheck ? 1 : 0

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:cnep')}</Typography>
        <CheckRiskStatus checkLength={checkLength} hasChecks={checkLength > 0} />
      </Paper>

      <CheckDetailTitle
        email={cnepCheck?.email}
        status={cnepCheck?.status}
        createdAt={cnepCheck?.createdAt}
        updatedAt={cnepCheck?.updatedAt}
      />

      {hasObjectCheck && (
        <Paper elevation={0} variant="rootOutlined">
          <div className="c-detail-row">
            <Typography variant="subtitle1">{t('common:information')}</Typography>
            <Typography variant="subtitle3">{cnepCheck.checkDetails.informação}</Typography>
          </div>
        </Paper>
      )}

      {hasArrayChecks &&
        cnepCheck.checkDetails.map((element, index) => (
          <TimelineDotLine key={index}>
            <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
              <div className="c-detail-grid">
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:initialDate')}</Typography>
                  <Typography variant="subtitle3">{element.dataInicioSancao ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:endDate')}</Typography>
                  <Typography variant="subtitle3">{element.dataFimSancao ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:sanctionDescription')}</Typography>
                  <Typography variant="subtitle3">{element.tipoSancao?.descricaoResumida ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:sanctioningBody')}</Typography>
                  <Typography variant="subtitle3">{element.orgaoSancionador?.nome ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:fineValue')}</Typography>
                  <Typography variant="subtitle3">{element.valorMulta ?? '---'}</Typography>
                </div>
              </div>
            </Paper>
          </TimelineDotLine>
        ))}
    </>
  )
}

export default CheckCnep

/* import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'

const variantByLevel = {
  0: 'h3',
  1: 'h4',
}

const CheckCnep = ({ title = '', cnepCheck, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])
  return (
    <Box className="detail-group">
      <Typography variant={variantByLevel[level] || variantByLevel[0]}>{title || t('common:cnep')}</Typography>
      <CheckDetailTitle
        email={cnepCheck?.email}
        status={cnepCheck?.status}
        createdAt={cnepCheck?.createdAt}
        updatedAt={cnepCheck?.updatedAt}
      />
      {!Array.isArray(cnepCheck?.checkDetails) && cnepCheck?.checkDetails?.informação && (
        <Box>
          <span>{t('common:information')}</span>
          <p>{cnepCheck?.checkDetails?.informação ?? '---'}</p>
        </Box>
      )}
      {Array.isArray(cnepCheck?.checkDetails) && cnepCheck?.checkDetails?.length && (
        <Box>
          <h4>{t('common:sanctions')}</h4>
          <Box className="group-table">
            <table className="bs bst group-table">
              <thead>
                <tr className="group-table">
                  <th className="bs">{t('common:initialDate')}</th>
                  <th className="bs">{t('common:endDate')}</th>
                  <th className="bs">{t('common:sanctionDescription')}</th>
                  <th className="bs">{t('common:sanctioningBody')}</th>
                  <th className="bs">{t('common:fineValue')}</th>
                </tr>
              </thead>
              <tbody>
                {cnepCheck?.checkDetails?.map((element, index) => {
                  return (
                    <tr className="group-table" key={index}>
                      <td className="bs table-cell col-5">{element.dataInicioSancao ?? '---'}</td>
                      <td className="bs table-cell col-5">{element.dataFimSancao ?? '---'}</td>
                      <td className="bs table-cell col-5">{element.tipoSancao?.descricaoResumida ?? '---'}</td>
                      <td className="bs table-cell col-5">{element.orgaoSancionador?.nome ?? '---'}</td>
                      <td className="bs table-cell col-5">{element.valorMulta ?? '---'}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default CheckCnep
 */
